import axios from "axios";
import React, { useEffect, useState, useRef, useCallback } from "react";

// table-next
import filterFactory, { textFilter } from "react-bootstrap-table2-filter";
import BoostrapTable from "react-bootstrap-table-next";
import paginationFactory from "react-bootstrap-table2-paginator";
import {
  FormSelectBlack,
  PageOptions,
  PageOptionsPvNx,
} from "../../components/PageParams";
import cellEditFactory from "react-bootstrap-table2-editor";

import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components";
import { HttpJsonHeader } from "../../../features/Environments";
import { setReminder } from "../../../features/UserActions";
import { Button, Modal, OverlayTrigger, Tooltip } from "react-bootstrap";
import {
  AiOutlineCheck,
  AiOutlineDoubleLeft,
  AiOutlineDoubleRight,
  AiOutlineMinus,
  AiOutlinePlus,
} from "react-icons/ai";
import {
  ModalBodyBlack,
  ModalHeaderBlack,
} from "../../../features/RadConnStyle";
import { GetConfirmTitle } from "../../components/ConfirmDialog";
import Loading from "../../../components/Loading";

const BranchPricelistPopup = (props) => {
  const userDetail = useSelector((state) => state.user.detail);
  const [winState, setWinState] = props.winState;
  const { selectedRow, formName, setUpdateFlag, dataX } = props;
  const { showConfirm, setShowConfirm, confirmAction, setConfirmAction } =
    props;

  const [loading, setLoading] = useState(false);

  const [freshGood, setFreshGood] = useState(false);
  const [curLeftItem, setCurLeftItem] = useState(null);

  const [patiRight, setPatiRight] = useState([]);
  const [priceData, setPriceData] = useState([]);
  const [showSaveOk, setShowSaveOk] = useState(false);
  const [data, setData] = useState(null);
  const [good, setGood] = useState([]);
  const [dataFlw, setDataFlw] = useState([]);
  const [rowsEdited, setRowEdited] = useState([]);
  const dispatch = useDispatch();
  const refPriceTb = useRef();

  // const formName = "รายการสินค้าบริการสาขา";
  const [paramsPrice, setParamsPrice] = useState({
    custid: -1,
    brchpatrightid: -1,
    pricelistid: -1,
  });

  const [paramsGood, setParamsGood] = useState({
    goodcateid: -1,
    gdmodid: -1,
    gdspecialtyid: -1,
    gdspcsubid: -1,
  });

  const itemType = {
    PATRIGHT: 1,
    CATEGORY: 2,
    MODALITY: 3,
    SPECIALTY: 4,
    SPCSUB: 5,
  };

  //----------------------------------------------------------------------
  useEffect(() => {
    setRowEdited([]);
    getBrachRight();
    // if (selectedRow) {
    //   refreshPrice();
    // }
  }, [selectedRow]);

  //------------------------ รายชื่อสิทธิรักษา ----------------------------------------------
  //   useEffect(() => {
  //     getBrachRight();
  //  }, [selectedRow]);

  useEffect(() => {
    //loadGoods();
    listGoodsParamsSelector();
  }, []);

  useEffect(() => {
    if (winState.show) {
      try {
        setParamsPrice((pv) => {
          pv.pricelistid = selectedRow.row.price_list_id;
          return { ...pv };
        });
      } catch (error) {
        console.log(error);
      }

      /** clear data when close this popup */
      return () => {
        setParamsPrice({ custid: -1, brchpatrightid: -1, pricelistid: -1 });
        setPriceData([]);
      };
    }
  }, [winState.show]);

  /** Check PRICES */
  useEffect(() => {
    if (paramsPrice.brchpatrightid > 0) {
      refreshPrice();
    }
    resetData();
  }, [paramsPrice]);

  const resetData = () => {
    setPriceData([]);
  };

  useEffect(() => {
    loadGoods();
  }, [paramsGood]);

  //** ALL FUNCTIONS */
  const refreshPrice = () => {
    setLoading(true);
    axios
      .post(
        process.env.REACT_APP_API +
          "api/goodbranch/get-branch-pricelist-detail",
        {
          UserInfo: userDetail,
          SearchInfo: { ...paramsGood, ...paramsPrice },
          PricelistInfo: selectedRow?.row,
        },
        HttpJsonHeader,
      )
      .then((res) => {
        if (res.data) {
          setPriceData(res.data && res.data.rows);
          setLoading(false);
        }
      })
      .catch((err) =>
        dispatch(setReminder({ show: true, message: err.message })),
      );
  };

  /**เลือกแถว แล้วสั่งบันทึกด้วย SaveSingle   */
  const updateSingle = (item) => {
    setCurLeftItem(item);
  };

  useEffect(() => {
    /** เมื่อมีการคลิกปุ่ม [+] จากรายการด้านซ้าย   */
    /** Update Item และทำการสัง SAVE NEW */
    if (curLeftItem !== null) {
      SaveSingle();
    }
  }, [curLeftItem]);

  /** บันทึก 1 รายการ */
  const SaveSingle = () => {
    if ([paramsPrice.brchpatrightid] < 0) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกสิทธิรักษา",
          type: "error",
        }),
      );
      return;
    }

    axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/insert-single-item",
        {
          PricelistInfo: selectedRow?.row,
          ItemInfo: { ...curLeftItem, ...paramsGood, ...paramsPrice },
          UserInfo: userDetail,
        },
        HttpJsonHeader,
      )
      .then((res) => {
        // setUpdateFlag(true);
        if (res.data?.msg === "duplicate") {
          dispatch(
            setReminder({
              show: true,
              message: "ไม่สามารถบันทึกได้ เนื่องจากมีบันทึกแล้ว",
              type: "error",
            }),
          );
        }

        refreshPrice();
        setLoading(false);
        setCurLeftItem(null);
      })
      .catch((err) => {
        dispatch(
          setReminder({
            show: true,
            message: "ไม่สามารถบันทึกได้",
            type: "error",
          }),
        );
        setCurLeftItem(null);
      });
  };

  //--------------------  update ราคา ----------------------------------------
  const UpdateBatchPrice = (goReady) => {
    if (paramsPrice.brchpatrightid < 1) {
      dispatch(
        setReminder({
          show: true,
          message: "กรุณาเลือกสิทธิรักษา",
          type: "error",
        }),
      );
      return;
    }

    setLoading(true);

    axios
      .post(
        process.env.REACT_APP_API + "api/pricelist/update-batch-price",
        {
          UserInfo: userDetail,
          ItemsInfo: rowsEdited,
        },
        HttpJsonHeader,
      )
      .then((res) => {
        setLoading(false);
        dispatch(
          setReminder({
            show: true,
            message: "ปรับปรุงสมบูรณ์",
            type: "success",
          }),
        );
        setShowSaveOk(false);
        setRowEdited([]);
        setUpdateFlag(true);
      })
      .catch((err) => {
        setLoading(false);
        dispatch(
          setReminder({
            show: true,
            message: "ไม่สามารถบันทึกได้",
            type: "error",
          }),
        );
      });
  };
  //------------------------ ยกเลิกทีละรายการ ----------------------------------------------
  const handelRemove = (row) => {
    // (row);
    setShowConfirm(true);
    setConfirmAction({
      title: GetConfirmTitle("DELETE"),
      data: row,
      action: (row) => {
        axios
          .post(
            process.env.REACT_APP_API + "api/pricelist/remove-single-price",
            {
              ItemsInfo: [row],
              UserInfo: userDetail,
            },
            HttpJsonHeader,
          )
          .then((res) => {
            refreshPrice();
            setUpdateFlag(true);
            // dispatch(
            //   setReminder({
            //     show: true,
            //     message: "ยกเลิกสมบูรณ์",
            //     type: "success",
            //   })
            // );
          })
          .catch((err) => {
            dispatch(
              setReminder({ show: true, message: err.message, type: "error" }),
            );
          });
      },
    });
  };

  const getBrachRight = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/patient-rights/get-branch-short",
        {
          UserInfo: userDetail,
          SearchTxt: "",
        },
        HttpJsonHeader,
      )
      .then((res) => {
        setPatiRight(res.data && res.data.rows);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        ),
      );
  };

  //----------------------------------------------------------------------
  const loadGoods = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goodbranch/get-branch-data",
        {
          UserInfo: userDetail,
          SearchInfo: { ...paramsGood, ...paramsPrice },
        },
        HttpJsonHeader,
      )
      .then((res) => {
        res.data && setGood(res.data.rows);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        ),
      );
  };

  //----------------------------------------------------------------------

  const listGoodsParamsSelector = () => {
    axios
      .post(
        process.env.REACT_APP_API + "api/goods/selected-lists",
        { UserInfo: userDetail, SearchTxt: "" },
        HttpJsonHeader,
      )
      .then((res) => {
        res.data && setDataFlw(res.data);
      })
      .catch((err) =>
        dispatch(
          setReminder({ show: true, message: err.message, type: "error" }),
        ),
      );
  };

  //----------------------------------------------------------------------
  const msgbox = (text) => {
    dispatch(setReminder({ show: true, message: text, type: "success" }));
  };

  //----------------------------------------------------------------------
  const getHeaderStyle = (wi) => {
    return {
      width: wi,
      background: "var(--table-header-back-color)",
    };
  };
  //----------------------------------------------------------------------
  const customTextFilter = {
    placeholder: "...",
  };
  //----------------------------------------------------------------------

  const changeParams = (iType, e) => {
    // let refreshGood = false;
    switch (iType) {
      case itemType.PATRIGHT:
        if (paramsPrice.brchpatrightid === e.target.value) break;
        setParamsPrice((pv) => {
          pv.brchpatrightid = e.target.value === null ? -1 : e.target.value;
          return { ...pv };
        });
        break;
      case itemType.CATEGORY:
        if (paramsGood.goodcateid === e.target.value) break;
        setParamsGood((pv) => {
          pv.goodcateid = e.target.value;
          return { ...pv };
        });

        break;
      case itemType.SPECIALTY:
        if (paramsGood.gdspecialtyid === e.target.value) break;
        setParamsGood((pv) => {
          pv.gdspecialtyid = e.target.value;
          return { ...pv };
        });

        break;
      case itemType.SPCSUB:
        if (paramsGood.gdspcsubid === e.target.value) break;
        setParamsGood((pv) => {
          pv.gdspcsubid = e.target.value;
          return { ...pv };
        });

        break;
      case itemType.MODALITY:
        if (paramsGood.gdmodid === e.target.value) break;
        setParamsGood((pv) => {
          pv.gdmodid = e.target.value;
          return { ...pv };
        });

        break;
      default:
        break;
    }
    // if (refreshGood) {
    //   setFreshGood(true);
    // }
  };
  //----------------------------------------------------------------------
  const formatSend = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>ใช้</Tooltip>}
        >
          <BtnSend
            onClick={() => {
              updateSingle(row);
            }}
          >
            <AiOutlinePlus style={{ marginLeft: "-8px", marginTop: "-15px" }} />
          </BtnSend>
        </OverlayTrigger>
      </div>
    );
  };
  const formatRtn = (x, row) => {
    return (
      <div>
        <OverlayTrigger
          placement="top"
          overlay={(props) => <Tooltip {...props}>เอาออก</Tooltip>}
        >
          <BtnSend
            variant="danger"
            onClick={() => {
              handelRemove(row);
            }}
          >
            <AiOutlineMinus
              style={{ marginLeft: "-8px", marginTop: "-15px" }}
            />
          </BtnSend>
        </OverlayTrigger>
      </div>
    );
  };
  //-------------  Column รายการสินค้า ----------------------------------------
  const colGoodMain = [
    {
      dataField: "goodcode",
      text: "รหัส",
      sort: true,
      headerStyle: () => getHeaderStyle("80px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "goodname",
      text: "ชื่อสินค้า",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
      },
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "none",
      text: "-",
      headerStyle: () => getHeaderStyle("40px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      formatter: formatSend,
    },
  ];
  //-------------------Columns ราคา ----------------------------------------
  const colPrice = [
    {
      dataField: "goodname",
      text: "สินค้า-บริการ",
      sort: true,
      headerStyle: () => getHeaderStyle("auto"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "left",
        paddingLeft: "20px",
      },
      filter: textFilter(customTextFilter),
      editable: false,
    },
    {
      dataField: "price",
      text: "เรียกเก็บ",
      sort: true,
      headerStyle: () => getHeaderStyle("100px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "right",
      },
      formatter: decimalCellFormat,
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "price_df",
      text: "DF(เข้า-บ่าย)",
      sort: true,
      headerStyle: () => getHeaderStyle("120px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "right",
      },
      formatter: decimalCellFormat,
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "price_df_night",
      text: "DF(ดึก)",
      sort: true,
      headerStyle: () => getHeaderStyle("100px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "right",
      },
      formatter: decimalCellFormat,
      filter: textFilter(customTextFilter),
    },
    {
      dataField: "none",
      text: "-",
      headerStyle: () => getHeaderStyle("40px"),
      style: {
        border: "none",
        color: "var(--table-text-color)",
        textAlign: "center",
      },
      formatter: formatRtn,
      editable: false,
    },
  ];
  //------------  คีย์ราคา  --------------------------------------------------
  const actionPriceChange = async (oldValue, newValue, row, column, done) => {
    setRowEdited(
      (pv) =>
        pv && pv.filter((r) => r.price_list_det_id !== row.price_list_det_id),
    );
    setRowEdited((old) => (old ? [...old, row] : row));
    setShowSaveOk(true);
    done();
  };

  //----------------------------------------------------------------------
  return (
    <Modal
      show={winState.show}
      // size="xl"
      centered
      backdrop={false}
      onHide={() => setWinState({ show: false })}
      style={{ fontSize: "12px" }}
      fullscreen
    >
      {loading ? <Loading /> : <></>}
      <ModalHeaderBlack style={{ textAlign: "center" }} closeButton>
        เพิ่มแก้ไข {`${formName ? formName : "รายการ"}`}
      </ModalHeaderBlack>

      <ModalBodyBlack>
        <div
          style={{
            backgroundColor: "#212131",
            flex: "1",
            width: "100%",
            display: "flex",
            flexDirection: "row",
            justifyContent: "center",
            fontSize: "14px",
            padding: "5px",
          }}
        >
          <SBox2>
            ประเภทสินค้า:
            <FormSelectBlack
              /// ref = {(el)=> fromRef.current['001'] = el}
              style={selectionStyle}
              aria-label="ตัวเลือก"
              addFirstRow={true}
              firstRowText="ทั้งหมด"
              name={"goodCateId"}
              rows={dataFlw && dataFlw.GoodCate}
              onChange={(e) => {
                changeParams(itemType.CATEGORY, e);
              }}
            />
          </SBox2>
          <SBox2>
            Modality:
            <FormSelectBlack
              style={selectionStyle}
              aria-label="ตัวเลือก"
              // leadtype="all"
              addFirstRow={true}
              firstRowText="ทั้งหมด"
              name={"goodModalityId"}
              rows={dataFlw && dataFlw.GoodModality}
              onChange={(e) => {
                changeParams(itemType.MODALITY, e);
              }}
            />
          </SBox2>
          <SBox2>
            Specialty:
            <FormSelectBlack
              style={selectionStyle}
              aria-label="ตัวเลือก"
              addFirstRow={true}
              firstRowText="ทั้งหมด"
              name={"goodspc"}
              rows={dataFlw && dataFlw.GoodSpc}
              onChange={(e) => {
                changeParams(itemType.SPECIALTY, e);
              }}
            />
          </SBox2>
          <SBox2>
            Sub Specialty:
            <FormSelectBlack
              style={selectionStyle}
              aria-label="ตัวเลือก"
              addFirstRow={true}
              firstRowText="ทั้งหมด"
              name={"subspc"}
              rows={dataFlw && dataFlw.GoodSpcSub}
              onChange={(e) => {
                changeParams(itemType.SPECIALTY, e);
              }}
            />
          </SBox2>
        </div>

        <VBox>
          {/* ---------------------------------------------------------- */}
          <HBox style={{ fontSize: "13px", padding: "5px" }}>
            <VBox>
              <div
                style={{
                  color: "white",
                  width: "100%",
                  textAlign: "left",
                  paddingLeft: "10px",
                  height: "62px",
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                  flexDirection: "column",
                }}
              >
                <div style={{ fontSize: "25px", color: "yellow" }}>
                  รายชื่อส่วนตรวจหลัก
                </div>
                <div style={{ fontSize: "12px", color: "white" }}>
                  คลิกปุ่ม{" "}
                  <BtnSend>
                    <AiOutlinePlus
                      style={{ marginLeft: "-8px", marginTop: "-15px" }}
                    />{" "}
                  </BtnSend>
                  {"   "}เพื่อเพิ่มรายการส่วนตรวจประจำ รพ.
                </div>
              </div>
              {/* -------------------------------------------------------------- */}
              <BoostrapTable
                bootstrap4
                keyField="goodid"
                rowClasses={"table-next-rows-style"}
                data={good}
                columns={colGoodMain}
                striped
                hover
                condensed
                headerWrapperClasses="headerWrapper"
                wrapperClasses="bs-table-wrapper"
                bordered={true}
                pagination={paginationFactory(PageOptionsPvNx)}
                filter={filterFactory()}
              />
            </VBox>
            {/* ----------------------- RIGHT PANEL -------------------------------- */}
            <div style={{ width: "20px" }}></div>

            <VBox>
              <div>
                <SBox style={{ flex: 1 }}>
                  สิทธิรักษาประจำโรงพยาบาล:
                  <FormSelectBlack
                    addFirstRow={true}
                    firstRowText="เลือกสิทธิ"
                    style={selectionStyle}
                    aria-label="ตัวเลือก"
                    name={"brchid"}
                    rows={patiRight && patiRight}
                    onChange={(e) => {
                      changeParams(itemType.PATRIGHT, e);
                    }}
                  />
                </SBox>
                <BoostrapTable
                  bootstrap4
                  ref={(n) => (refPriceTb.current = n)}
                  keyField="price_list_det_id"
                  rowClasses={"table-next-rows-style"}
                  data={priceData}
                  columns={colPrice}
                  striped
                  hover
                  condensed
                  headerWrapperClasses="headerWrapper"
                  wrapperClasses="bs-table-wrapper"
                  bordered={true}
                  pagination={paginationFactory(PageOptions)}
                  filter={filterFactory()}
                  cellEdit={cellEditFactory({
                    mode: "click",
                    blurToSave: true,
                    beforeSaveCell: actionPriceChange,
                  })}
                  selectRow={{
                    mode: "checkbox",
                    hideSelectColumn: true,
                    hideSelectAll: true,
                  }}
                />

                <ConfirmBox2 show={showSaveOk}>
                  <Button
                    // style={{ marginRight: "10px" }}
                    onClick={() => UpdateBatchPrice()}
                  >
                    <AiOutlineCheck style={{ marginRight: "5px" }} />
                    บันทึก
                  </Button>

                  <Button
                    variant="danger"
                    onClick={() => {
                      setRowEdited([]);
                      setShowSaveOk(false);
                    }}
                  >
                    ไม่บันทึก
                  </Button>
                </ConfirmBox2>
              </div>
            </VBox>
          </HBox>
        </VBox>
      </ModalBodyBlack>
    </Modal>
  );
};

const btnStyle = {
  margin: "5px",
};

const HBox = styled.div`
  flex: 1;
  display: flex;
`;

const VBox = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  /* background-color: red; */
`;

const SBox = styled.div`
  color: white;
  margin: 5px;
`;

const SBox2 = styled.div`
  flex: 1;
  color: white;
  margin: 5px;
`;

const BtnSend = styled(Button)`
  width: 18px;
  height: 25px;
  border-radius: 20px 20px 20px 20px;
  &:hover {
    background-color: yellow;
    color: black;
    transform: rotate((20deg));
  }
`;

const ConfirmBox = styled.div`
  position: absolute;
  bottom: 10px;
  right: 50px;
  margin-right: 50px;
  padding: 1px 50px;
  z-index: 1000;
  border-radius: 5px 5px 5px 5px;
  flex: 1;

  ${(props) => {
    if (props.show) {
      return ` 
            visibility: visible;        
            transition: 0.3s ease-in;
            opacity: 1;
            right: -50px;                   
          `;
    } else {
      return ` 
            visibility: hidden;            
            transition: 0.7s ease-out;  
            opacity : 0;
            right:-80px;
          `;
    }
  }}
`;

const ConfirmBox2 = styled.div`
  display: flex;
  width: 100%;
  margin-right: 50px;
  padding: 1px 50px;
  z-index: 1000;
  border-radius: 5px 5px 5px 5px;
  flex: 1;
  justify-content: space-between;
  background-color: yellow;
  ${(props) => {
    if (props.show) {
      return ` 
            visibility: visible;        
            transition: 0.3s ease-in;
            opacity: 1;
            right: -50px;                   
          `;
    } else {
      return ` 
            visibility: hidden;            
            transition: 0.7s ease-out;  
            opacity : 0;
            right:-80px;
          `;
    }
  }}
`;

const selectionStyle = { color: "var(--select-item-color)", fontSize: "14px" };

const decimalCellFormat = (cell, row) => {
  return Number(cell).toLocaleString("th-TH", {
    style: "decimal",
    minimumFractionDigits: 2,
  });
};

export default BranchPricelistPopup;
